const asObject = (value) => value && typeof value === "object" && !Array.isArray(value) ? value : null;

const responseContainers = (response) => {
  const root = asObject(response) || {};
  return [root, asObject(root.data), asObject(root.result), asObject(root.payload)].filter(Boolean);
};

/**
 * Normalise les contrats de listes rencontrés entre les builds/API Elakay.
 * Une clé de facet explicite reste prioritaire, même lorsqu'elle est vide;
 * sinon on accepte les alias historiques products/items/results/docs/rows.
 */
export const resolveProductRows = (response, facetKeys = []) => {
  if (Array.isArray(response)) return response;
  const containers = responseContainers(response);
  const explicitKeys = [...new Set((Array.isArray(facetKeys) ? facetKeys : [facetKeys]).filter(Boolean))];

  for (const key of explicitKeys) {
    for (const container of containers) {
      if (Array.isArray(container[key])) return container[key];
    }
  }

  const aliases = ["products", "items", "results", "docs", "rows"];
  const candidates = [];
  for (const key of aliases) {
    for (const container of containers) {
      if (Array.isArray(container[key])) candidates.push(container[key]);
    }
  }
  return candidates.find((rows) => rows.length > 0) || candidates[0] || [];
};

export const resolveProductMeta = (response, rows, { totalKeys = [] } = {}) => {
  const containers = responseContainers(response);
  const readNumber = (keys) => {
    for (const key of keys) {
      for (const container of containers) {
        const value = Number(container[key]);
        if (Number.isFinite(value) && value >= 0) return value;
      }
    }
    return undefined;
  };

  return {
    size: readNumber(["size", "count", "pageSize", "returnedCount"]) ?? rows.length,
    total: readNumber([...totalKeys, "siseProduct", "total", "totalCount", "countDocuments"]) ?? rows.length,
  };
};
